import { Icon } from '@bechtel/gds';
import { PersonaType } from '@bechtel/types';
import styled, { css } from 'styled-components';

function getPersonaGridCoumns({ personaType }: ThreeWLAItemContainerStyledProps) {
  switch (personaType) {
    case PersonaType.FOREMAN:
      return css`
        grid-template-columns: calc(40% - 58px) 1fr 1fr 1fr 1fr;
      `;
    case PersonaType.GENERAL_FOREMAN:
      return css`
        grid-template-columns: calc(40% - 34px) 1fr 1fr 1fr 1fr;
      `;
    default:
      return css`
        grid-template-columns: calc(40% - 10px) 1fr 1fr 1fr 1fr;
      `;
  }
}

function getPlaceholderSize({ personaType }: ThreeWLAItemContainerStyledProps) {
  switch (personaType) {
    case PersonaType.FOREMAN:
      //li padding 16px + ul margin 24px + GF 40px*/
      return css`
        left: -96px;
        width: 96px;
      `;
    case PersonaType.GENERAL_FOREMAN:
      //li padding 16px + ul margin 24px*/
      return css`
        left: -56px;
        width: 56px;
      `;
    default:
      //li padding 16px
      return css`
        left: -${({ theme }) => theme.spacings[500]};
        width: ${({ theme }) => theme.spacings[500]};
      `;
  }
}

export interface ThreeWLAItemContainerStyledProps {
  personaType: PersonaType;
  selected: boolean;
}

export const ThreeWLAItemContainerStyled = styled.div<ThreeWLAItemContainerStyledProps>`
  position: relative;
  display: grid;
  ${getPersonaGridCoumns}

  ${({ theme, selected }) => css`
    background-color: ${selected ? theme.colors.grey[100] : theme.colors.white};
  `}
`;

export const ThreeWLAPlaceholderStyled = styled.div<ThreeWLAItemContainerStyledProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  ${getPlaceholderSize}
  ${({ theme, selected }) => css`
    background-color: ${selected ? theme.colors.grey[100] : theme.colors.white};
  `}
`;

export const ThreeWLAItemPersonaStyled = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding-top: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    border-right: 1px solid ${theme.colors.grey[300]};
    align-items: top;
    display: grid;
    grid-template-columns: ${theme.spacings[700]} auto auto;
  `}
`;

export const ThreeWLAItemWeekStatStyled = styled.div`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    border-right: 1px solid ${theme.colors.grey[300]};
    display: grid;
    grid-template-rows: 18px 18px 18px 18px 28px;
    grid-row-gap: 10px;
    padding-bottom: ${theme.spacings[450]};
  `}
`;

export const ThreeWLAItemWeekStatHeaderStyled = styled.div`
  justify-content: right;
  display: grid;
  grid-template-rows: 18px 18px 18px 18px;
  grid-row-gap: 10px;
`;

export const ExpandCollapseIconStyled = styled(Icon)`
  ${({ theme }) => css`
    height: ${theme.spacings[700]};
    width: ${theme.spacings[700]};
    padding-right: ${theme.spacings[400]};
    align-items: top;
    justify-content: center;
    color: ${theme.colors.blue[800]};
    cursor: pointer;
  `}
`;

export const ExpandedItemBorderStyled = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.grey[300]};
  top: ${({ theme }) => theme.spacings[800]};
  bottom: 0;
  width: 1px;
  left: 10px;
  z-index: 1; /* Needed to show the tree lines & crew bullets on the top of placeholder container used for item selection */
`;
